export const QUANTITY_STEPPER_SIZE_XS = 40;
export const QUANTITY_STEPPER_SIZE_SM = 56;

export const ICON_SIZE_XS = 32;
export const ICON_SIZE_SM = 40;
